import { lazy } from "react";
import { Navigate } from "react-router-dom";
import { PATH_AFTER_LOGIN } from "src/config";
import AuthGuard, { AdminGuard } from "src/guards/AuthGuard";
import Loadable from "../Loadable";
import genRoutes from "./routes";

const AdminLayout = Loadable(lazy(() => import("src/layouts/layout")));

const genAdmin = (isSubAdmin = false) => {
  return [
    {
      path: "admin",
      element: (
        <AuthGuard>
          <AdminGuard>
            <AdminLayout />
          </AdminGuard>
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        ...genRoutes(isSubAdmin),
      ],
    },
  ];
};

export default genAdmin;
